import { useConnectDataAttributes } from '@/libs/api/connect/connect.composables.ts'
import { language } from '@/i18n/i18n.ts'
import { useConnectApiClient } from '@/libs/api/connect/connect-client.ts'

export const useConnectApiClientImpl = () => {
  const { clientId, secret, partnerId, locale } = useConnectDataAttributes()

  const client = useConnectApiClient(
    {
      client_id: clientId!,
      client_secret: secret!
    },
    {
      overwriteTokenKey: `shopconnect_access_token-${partnerId}-${language(locale ?? 'de')}`
    }
  )

  return {
    ...client
  }
}
